import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ObjectUsageDialogData {
  objects: Array<any>;
  hasUsageMessage: string;
}

@Component({
    selector: 'app-object-usage-dialog',
    templateUrl: './object-usage-dialog.component.html',
    styleUrls: ['./object-usage-dialog.component.scss'],
    standalone: false
})
export class ObjectUsageDialogComponent {
  // Injections
  public data: ObjectUsageDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<ObjectUsageDialogComponent> = inject(MatDialogRef);
}
